import { render } from "./SuspectUser.vue?vue&type=template&id=1dac8c4d&scoped=true&ts=true"
import script from "./SuspectUser.vue?vue&type=script&lang=ts"
export * from "./SuspectUser.vue?vue&type=script&lang=ts"

import "./SuspectUser.vue?vue&type=style&index=0&id=1dac8c4d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2816855756/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac8c4d"]])

export default __exports__